import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-reviewand-finalize',
  templateUrl: './reviewand-finalize.component.html',
  styleUrls: ['./reviewand-finalize.component.css']
})
export class ReviewandFinalizeComponent implements OnInit {
  step = 0;
  //ReconsoladatedPatientInfo: any = null;
  Reconsole_Problems: any = [];
  Reconsole_Allergy: any = [];
  Reconsole_Medications: any = [];

  Reconsole_Problems1: any = [];
  Reconsole_Allergy1: any = [];
  Reconsole_Medications1: any = [];
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,) {
    if (data) {
      this.Reconsole_Problems = data.Problems;
      this.Reconsole_Medications = data.Medications;
      this.Reconsole_Allergy = data.Allergy;
      this.Reconsole_Problems.forEach(element => {
        element.isChecked = true
        this.Reconsole_Problems1.push(element);
      });
      this.Reconsole_Medications.forEach(element => {
        element.isChecked = true
        this.Reconsole_Medications1.push(element);
      });
      this.Reconsole_Allergy.forEach(element => {
        element.isChecked = true
        this.Reconsole_Allergy1.push(element);
      });

    }

  }

  ngOnInit() {
  }
  fnclose() {
    this.dialogRef.close();
  }
  fnIsProblemsChecked() {
    if (this.Reconsole_Problems.length == 0)
      return false;
    return (this.Reconsole_Problems.length == this.Reconsole_Problems1.length)

  }
  fnProblemsCheckboxClick(isChecked: boolean) {
    if (isChecked == true) {
      this.Reconsole_Problems.forEach(element => {
        element.isChecked = true;
        this.Reconsole_Problems1.push(element);
      })
    }
    else {
      this.Reconsole_Problems.forEach(element => {
        element.isChecked = false;

      });
      this.Reconsole_Problems1 = [];
    }


  }


  fnSelectedProblems(element: any, event) {
    if (element.problemTypeCode == '') {
      alert("Map Problem in ICD");
      event.target.checked = false;
      element.isChecked = false;
      return;
    }
    this.Reconsole_Problems1 = this.Reconsole_Problems1.filter(i => i.problemTypeCode != element.problemTypeCode);
    if (event.target.checked == true) {
      element.isChecked = true;
      this.Reconsole_Problems1.push(element);
    }
    else element.isChecked = false;

  }

  fnIsAllergiesChecked() {
    if (this.Reconsole_Allergy.length == 0)
      return false;
    return (this.Reconsole_Allergy.length == this.Reconsole_Allergy1.length)

  }
  fnAllergiesCheckboxClick(isChecked: boolean) {
    if (isChecked == true) {
      this.Reconsole_Allergy.forEach(element => {
        element.isChecked = true;
        this.Reconsole_Allergy1.push(element);
      })
    }
    else {
      this.Reconsole_Allergy.forEach(element => {
        element.isChecked = false;
      });
      this.Reconsole_Allergy1 = [];
    }


  }
  fnSelectedAllergy(element: any, checked: boolean) {
    this.Reconsole_Allergy1 = this.Reconsole_Allergy1.filter(i => i.drugName != element.drugName);
    if (checked == true)
      this.Reconsole_Allergy1.push(element);
  }

  fnIsMedicationsChecked() {
    if (this.Reconsole_Medications.length == 0)
      return false;
    return (this.Reconsole_Medications.length == this.Reconsole_Medications1.length)

  }
  fnMedicationsCheckboxClick(isChecked: boolean) {
    if (isChecked == true) {
      this.Reconsole_Medications.forEach(element => {
        element.isChecked = true;
        this.Reconsole_Medications1.push(element);
      })
    }
    else {
      this.Reconsole_Medications.forEach(element => {
        element.isChecked = false;
      });
      this.Reconsole_Medications1 = [];
    }


  }

  fnSelectedMedication(element: any, checked: boolean) {
    this.Reconsole_Medications1 = this.Reconsole_Medications1.filter(i => i.medicationCode != element.medicationCode);
    if (checked == true)
      this.Reconsole_Medications1.push(element);
  }
  fnReviewandFinalize() {
    const result = {
      Reconsole_Problems: this.Reconsole_Problems1,
      Reconsole_Allergy: this.Reconsole_Allergy1,
      Reconsole_Medications: this.Reconsole_Medications1
    }
    this.dialogRef.close(result);
  }


}
